'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../../common.blocks/i-bem/i-bem.react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'select2',
    elem: 'menu',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this._hoverOnOpen = this._hoverOnOpen.bind(this);
    },
    didUpdate: function didUpdate() {
        this.__base.apply(this, arguments);

        this.context.wasOpened && this._menu.items.length && this._hoverOnOpen();
    },
    _hoverOnOpen: function _hoverOnOpen() {
        var menu = this._menu;

        if (!menu.items.length) {
            return;
        }

        var checked = menu.items.filter(function (item) {
            return item.props.checked;
        })[0];
        var hovered = menu._hoveredItem;

        if (!hovered) {
            if (checked) {
                menu.hoverText(checked.getText());
            } else {
                menu.hoverItem(menu.items[0]);
                menu.scrollToItem(menu.items[0]);
            }
        }
    }
}, {
    contextTypes: {
        getMenu: _propTypes2.default.func,
        wasOpened: _propTypes2.default.bool
    }
});